import { useState } from 'react'
import { intersection, isEmpty } from 'lodash'

import { useAuth } from '@praxis/component-auth'

import apiConfig from '../../config/apiConfig'

const useUser = () => {
  const {
    session: {
      userInfo: { accessToken, email, lanId, memberOf },
    },
  } = useAuth()

  const isUser = !isEmpty(
    intersection(memberOf, apiConfig.auth.requiredPermissions.user),
  )

  const isAdmin = !isEmpty(
    intersection(memberOf, apiConfig.auth.requiredPermissions.admin),
  )

  const isCarrier = !isEmpty(
    intersection(memberOf, apiConfig.auth.requiredPermissions.carrier),
  )

  const isAuction = !isEmpty(
    intersection(memberOf, apiConfig.auth.requiredPermissions.auction),
  )

  const userInfo = {
    accessToken,
    email,
    lanId,
    access: {
      isUser,
      isAdmin,
      isCarrier,
      isAuction,
      hasBaseAccess: isUser || isAdmin || isCarrier || isAuction,
    },
  }

  const [user] = useState(userInfo)

  return user
}

export default useUser
